import { throwError as observableThrowError, Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch'
import { Injectable } from '@angular/core';
import { UserStatusesModel } from './user-statuses.datamodel';
import { CookieService } from 'web-common/src/app/cookie.service';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable()
export class UserStatusesService {

  constructor(private http: HttpClient, private cookieService: CookieService) { }

  private setHeaders(): HttpHeaders {
    let cookieString = 'id=' + this.cookieService.get('id') + '; user_token=' + this.cookieService.get('user_token') + ';';
    let headers = new HttpHeaders();
    headers.append('cookiestring', cookieString);
    headers.append('Content-Type', 'application/json');
    headers.append('apiversion', '1');
    headers.append('appid', environment.appId);

    return headers;
  }
  public fetchUsers = (pageNumber: number = 0, email: string = '', length: number = 50, showDisabled: boolean = false, lastActive: string = 'ALL',
                       showDisabledAccounts: boolean = true, showEnabledAccounts: boolean = true, onlyAdmins: boolean = false,
                       selectedRoles: string[] = [], selectedArea: string[] = [], selectedAdditional: string[] = [],
                       sortField: string, sortType: string):
    Observable<UserStatusesModel> => {

    const requestBody = {
      'pageNumber': pageNumber,
      'pageRecords': length,
      'search': decodeURIComponent(email.trim()),
      'lastActive': lastActive,
      'roles': selectedRoles,
      'areaOfFocus': selectedArea,
      'additionalProfileInformation': selectedAdditional,
      'showDisabledAccounts': showDisabledAccounts,
      'showEnabledAccounts': showEnabledAccounts,
      'onlyAdmins': onlyAdmins,
      'sortField': sortField,
      'sortType': sortType
    };

    return this.http.post<UserStatusesModel>(environment.rw3apiURL + 'user/institutionUsers/',
      requestBody,
      {headers: this.setHeaders()})
      .map((response) => {
        return response;
      })
      .catch( error => this.handleError(error));
  }

  public fetchInvited = (pageNumber: number = 0, email: string = '', length: number = 50):
    Observable<UserStatusesModel> => {

    const requestBody = {
      'pageNumber': pageNumber,
      'pageRecords': length,
      'search': decodeURIComponent(email.trim()),
      'sortField': 'email',
      'sortType': 'ASC'
    };

    return this.http.post<UserStatusesModel>(environment.rw3apiURL + 'user/admin/invites/',
      requestBody,
      {headers: this.setHeaders()})
      .map((response) => {
        return response;
      })
      .catch(this.handleError);
  }

  public getSummaryTableData = ():
    Observable<UserStatusesModel> => {

    return this.http.get<UserStatusesModel>(environment.rw3apiURL + 'user/admin/summary/',
{ headers: this.setHeaders() })
      .map((response) => {
        return response;
      }, error => {
        return error;
      });
  }

  public handleError (error: any) {
    // TODO: Use a remote logging infrastructure
    let errMsg: string;
    //! not sure if this works
    if (error.status) {
      const body = error || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return observableThrowError(errMsg);
  }


}
